module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-46.00a86f4b.png";